import { Controller } from "@hotwired/stimulus"

// Mobile only: the sidebar becomes an off-canvas panel, opened by the hamburger button in
// the top bar and closed by its backdrop. A real page navigation (Turbo Drive swaps the
// whole body on every admin link) resets this on its own - nothing to close explicitly there.
export default class extends Controller {
  static targets = ["panel", "backdrop", "toggle"]

  toggle() {
    const open = !this.panelTarget.classList.contains("is-open")
    this.panelTarget.classList.toggle("is-open", open)
    this.backdropTarget.classList.toggle("is-open", open)
    this.toggleTarget.setAttribute("aria-expanded", open)
  }

  close() {
    this.panelTarget.classList.remove("is-open")
    this.backdropTarget.classList.remove("is-open")
    this.toggleTarget.setAttribute("aria-expanded", "false")
  }
}
